import React from 'react';

import { Stack, Typography } from '@gogame/components';

import { ColorPreview } from './';

export const ColorLabelTextListItem = ({ name, color }) => {
  return (
    <Stack alignItems={'center'} direction={'row'}>
      <ColorPreview color={color} />
      <Typography>{name}</Typography>
    </Stack>
  );
};
